import { render, staticRenderFns } from "./PanelCompetitionStoper.vue?vue&type=template&id=a42d2432&scoped=true&"
import script from "./PanelCompetitionStoper.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionStoper.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionStoper.vue?vue&type=style&index=0&id=a42d2432&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42d2432",
  null
  
)

export default component.exports